import axios from 'axios';
import {baseUrl} from "../utils/utils";
import { Loading } from "element-ui";
let loading
function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function endLoading() {
  loading.close()
}
const service = axios.create({
  baseUrl : 'http://cms.saveus.cn',
  timeout: 15000 // 请求超时时间
});
service.interceptors.response.use(
  (res) => {
    console.log(res);
        startLoading()
    if (res.status === 200) {
      if (res.data.code === 0) {
        endLoading()
        return res.data;

      } else {
        tool.message(res.data.msg, 'error');
        return Promise.reject(res.data);
      }
    } else {
      tool.message(res.data.msg, 'error');
      return Promise.reject(res.data);
    }
  },
  (error) => {
    let r = error.response;
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js